import {
  SEND_INVITE_REQUEST,
  SEND_INVITE_SUCCESS,
  SEND_INVITE_FAILED,
  GET_DATA_FOR_INVITE_FORM_REQUEST,
  GET_DATA_FOR_INVITE_FORM_SUCCESS,
  GET_DATA_FOR_INVITE_FORM_FAILED,
} from './actionTypes';

export const sendInviteRequest = () => ({ type: SEND_INVITE_REQUEST });
export const sendInviteSuccess = () => ({
  type: SEND_INVITE_SUCCESS, success: 'Invite has been sent',
});
export const sendInviteFailure = (error) => ({ type: SEND_INVITE_FAILED, error });

export const getDataForInviteFormRequest = () => ({ type: GET_DATA_FOR_INVITE_FORM_REQUEST });
export const getDataForInviteFormSuccess = (organizations, registrationForms) => ({
  type: GET_DATA_FOR_INVITE_FORM_SUCCESS, organizations, registrationForms,
});
export const getDataForInviteFormFailure = (error) => ({
  type: GET_DATA_FOR_INVITE_FORM_FAILED, error,
});
